import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleChevronLeft.svg",
  "use": "CircleChevronLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleChevronLeft.svg\"><path d=\"M32,8A24,24,0,1,1,8,32,24,24,0,0,1,32,8ZM22.56,33.3975,33.5828,44.402a2.0016,2.0016,0,0,0,2.8324-2.829l-9.6063-9.59,9.6063-9.59a2.0016,2.0016,0,0,0-2.8324-2.8291L22.56,30.5685A1.9982,1.9982,0,0,0,22.56,33.3975Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol